import Chevron from './Chevron'
import Hamburger from './Hamburger'
const AnimatedIcons = { chevron: Chevron, hamburger: Hamburger }

export default AnimatedIcons
